import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import { toast } from 'react-toastify';
import { createCaisse } from '../../../actions/request/CaisseRequest';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import Select from "react-select";
import moment from 'moment';
import { useParams } from 'react-router-dom';


const CaisseForm = () => {


    const { id } = useParams();

    const dispatch = useDispatch();
    const { caisses, loadingCaisse } = useSelector((state) => state.caisses);
    const { vehicles, loadingVehicles } = useSelector((state) => state.vehicles);
    const { propertys, loadingPropertys } = useSelector((state) => state.propertys);
    const { reservations } = useSelector((state) => state.reservations);
    const [vehcileCaisseSelect, setvehcilCaisseSelect] = useState(null)
    const [propertyCaisseSelect, setpropertyCaisseSelect] = useState(null)
    const [reservationCaisseSelect, setreservationCaisseSelect] = useState(null)
    const [formSCaisse, setformSCaisse] = useState({
        type: "",          // ACOMPTE / CAUTION / PAIEMENT / SOLDE
        amount: "",        // Montant numérique
        currency: "",      // EUR / DZD / USD / CAD / MAD
        method: "",        // CASH / TRANSFERT / CHEQUE
        description: "",   // Texte libre
        reservation: id|| idreservation, // ObjectId ou null – alimenté par reservationCaisseSelect
        vehicle: null,     // ObjectId ou null – alimenté par vehicleCaisseSelect
        property: null,     // ObjectId ou null – alimenté par propertyCaisseSelect
        createdBy: getAndCheckLocalStorage(localStorageKeys.userId)
    })
    /* 3️⃣  Gestion des champs texte / select simples */


    const vehicleOptions = vehicles.map(item => ({ value: item._id, label: item.brand })) || [];
    const propertyOptions = propertys.map(item => ({ value: item._id, label: item.name })) || [];



    const [idreservation, setidreservation] = useState("");

    useEffect(()=>{
        setidreservation(id);
        setformSCaisse((prev) => ({ ...prev, reservation: id }));
    },[dispatch]);

    const handleInputCaisseChange = (e) => {
        const { name, value } = e.target;
        setformSCaisse((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmitCaisse = (e) => {
        // Vérification des champs obligatoires
        e.preventDefault();
        if (
            !formSCaisse.type ||
            !formSCaisse.amount ||
            !formSCaisse.currency ||
            !formSCaisse.method
        ) {
            toast.error("Veuillez remplir tous les champs obligatoires : Type, Montant, Monnaie, Méthode.", { position: "bottom-right" });
            return;
        }
        if (
            !formSCaisse.createdBy
        ) {
            toast.error("Veillez vous connecté s'il vous plais", { position: "bottom-right" });
            return;
        }

        // Vérifie que amount est bien un nombre positif
        const amountNumber = Number(formSCaisse.amount);
        if (isNaN(amountNumber) || amountNumber <= 0) {
            toast.error("Le montant doit être un nombre supérieur à zéro.", { position: "bottom-right" });
            return;
        }

        // Optionnel : vérifie qu'au moins une liaison est faite (réservation, véhicule ou propriété)
        if (!formSCaisse.reservation ) {
            toast.error("Réservation non trouvé", { position: "bottom-right" });
            return;
        }

        // Tout est valide, on envoie
        dispatch(createCaisse(formSCaisse));
    };



    return (
        <Card className="">
            <Card.Header><h4>Caisses</h4></Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmitCaisse}>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Type d'opération</Form.Label>
                                <Form.Select name="type" className="border rounded-sm" value={formSCaisse.type} onChange={handleInputCaisseChange} required>
                                    <option value="">-- Choisir --</option>
                                    <option value="ACOMPTE">Acompte</option>
                                    <option value="CAUTION">Caution</option>
                                    <option value="PAIEMENT">Paiement</option>
                                    <option value="SOLDE">Reste à payer</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Montant</Form.Label>
                                <Form.Control type="number" style={{ height: "40px" }} name="amount" value={formSCaisse.amount} onChange={handleInputCaisseChange} required min={0} />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Monnaie</Form.Label>
                                <Form.Select name="currency" className="border rounded-sm" value={formSCaisse.currency} onChange={handleInputCaisseChange} required>
                                    <option value="">-- Choisir --</option>
                                    <option value="EUR">Euros</option>
                                    <option value="DZD">Dinars</option>
                                    <option value="USD">USD</option>
                                    <option value="CAD">CAD</option>
                                    <option value="MAD">Dirhams</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Mode de paiement</Form.Label>
                                <Form.Select name="method" value={formSCaisse.method} className="border rounded-sm" onChange={handleInputCaisseChange} required>
                                    <option value="">-- Choisir --</option>
                                    <option value="CASH">Cash</option>
                                    <option value="TRANSFERT">Transfert</option>
                                    <option value="CHEQUE">Chèque</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Date</Form.Label>
                                <Form.Control type="date" style={{ height: "40px" }} name="date" value={formSCaisse.date} onChange={handleInputCaisseChange} required />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control as="textarea" rows={1} style={{ height: "40px" }} name="description" value={formSCaisse.description} onChange={handleInputCaisseChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    {
                        loadingCaisse ?
                            <Button variant="primary" type="button">
                                <Spinner variant='white' />
                            </Button>
                            :
                            <Button variant="primary" type="submit">
                                Enregistrer
                            </Button>
                    }

                </Form>

            </Card.Body>
        </Card>
    )
}

export default CaisseForm;